import { IRuleFactor, IRuleUsage } from '../services/rule/rule.model';
import { formatEmissionAmount, formatEmissionTonnes } from './emission-summary-utils';

const quantityFormat = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 });

/** "100 litres = 274.93 kgCO₂e (2025 factor)" */
export const formatRuleFactorExample = (factor: IRuleFactor): string => {
  const quantity = `${quantityFormat.format(factor.example.quantity)}${factor.example.unit ? ` ${factor.example.unit}` : ''}`;
  const year = factor.calendarYear ? ` (${factor.calendarYear} factor)` : '';
  return `${quantity} = ${formatEmissionAmount(factor.example.kgCO2e)}${year}`;
};

/** "15,400 litres" */
export const formatRuleQuantity = (usage: IRuleUsage, unit?: string | null): string =>
  `${quantityFormat.format(usage.quantity ?? 0)}${unit ? ` ${unit}` : ''}`;

/** "42.34 tCO₂e from 22 records" */
export const formatRuleEmissions = (usage: IRuleUsage): string => {
  const records = usage.records ?? 0;
  return `${formatEmissionTonnes(usage.emissionsKg ?? 0)} from ${records} record${records === 1 ? '' : 's'}`;
};
